import { Box, Card, Icon, Text, Title } from '@nimbus-ds/components';
import { ArrowRightIcon } from '@nimbus-ds/icons';
import { dateFormat, Format } from 'commons/utils/date';
import { useFrequencyTranslation } from 'domains/Billing/Checkout/hooks';
import { useFormatCurrency } from 'domains/Billing/hooks';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import { useSubscriptionDetail } from '../SubscriptionDetail/hooks';

export default function DowngradeDetail() {
  const t = useTranslationBilling(
    'checkout.conceptDetailContent.downgradeDetail',
  );
  const { currentPlan, newPlan, subscription } =
    useSubscriptionDetail('plan-cost');
  const formatCurrency = useFormatCurrency();
  const { getFrequencyInterval } = useFrequencyTranslation();
  if (!currentPlan || !newPlan || !subscription) return null;

  return (
    <Card>
      <Card.Header title={t('title')} />
      <Card.Body>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          gap="4"
        >
          <Card>
            <Box display="flex" flexDirection="column" gap="2">
              <Title as="h6">{currentPlan.name}</Title>
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
              >
                <Text>{t('cost')}</Text>
                <Box display="inline-flex" flexDirection="row">
                  <Text>
                    {formatCurrency(
                      currentPlan.price.value,
                      currentPlan.price.currency,
                    )}
                  </Text>
                  <Text fontSize="caption">{`/ ${getFrequencyInterval({
                    recurringFrequency: 'M',
                    recurringInterval: 1,
                  })}`}</Text>
                </Box>
              </Box>
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
              >
                <Text>{t('lastPayment')}</Text>
                <Text>
                  {dateFormat(
                    subscription.lastExecutionDate,
                    Format.DD_MM_YYYY,
                  )}
                </Text>
              </Box>
            </Box>
          </Card>
          <Icon source={<ArrowRightIcon size="large" />} />
          <Card backgroundColor="primary-surface">
            <Box display="flex" flexDirection="column" gap="2">
              <Title as="h6">{newPlan.name}</Title>
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
              >
                <Text>{t('cost')}</Text>
                <Box display="inline-flex" flexDirection="row">
                  <Text>
                    {formatCurrency(
                      newPlan.price.value,
                      newPlan.price.currency,
                    )}
                  </Text>
                  <Text fontSize="caption">{`/ ${getFrequencyInterval({
                    recurringFrequency: 'M',
                    recurringInterval: 1,
                  })}`}</Text>
                </Box>
              </Box>
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
              >
                <Text>{t('nextPayment')}</Text>
                <Text>
                  {dateFormat(
                    subscription.nextExecutionDate,
                    Format.DD_MM_YYYY,
                  )}
                </Text>
              </Box>
            </Box>
          </Card>
        </Box>
      </Card.Body>
    </Card>
  );
}
